// extracted by mini-css-extract-plugin
export default {"finished_list":"listRegisterFinishedRoutes_finished_list__WRZ+6","red_circle":"listRegisterFinishedRoutes_red_circle__Mxt9P","close":"listRegisterFinishedRoutes_close__PzX6G"};